module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('div', {
    staticClass: "subs-panel"
  }, [_c('div', {
    staticClass: "slide-in__mask animated fadeIn",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideIn"
    }
  }, [(_vm.animate) ? _c('div', {
    staticClass: "slide-in text-dark"
  }, [_c('div', {
    staticClass: "slide-in__header"
  }, [_c('div', {
    staticClass: "slide-in__header__close pointer icon__bg-circle",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.add_sub_to_several_lesson')))])]), _vm._v(" "), _c('div', {
    staticClass: "slide-in__grid"
  }, [_c('div', {
    staticClass: "slide-in__content"
  }, [_c('div', {
    staticClass: "slide-in__content__header"
  }, [_c('div', {
    staticClass: "slide-in__content__header__left"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.default_thumb_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.absenceReasons), function(absence) {
    return _c('AbsenceReason', {
      key: absence.id,
      attrs: {
        "user_calendar_id": _vm.user.user_calendar_id,
        "reason": absence
      },
      on: {
        "close": _vm.close
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide-in__content__body"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.choose_period_lessons')))]), _vm._v(" "), _c('DoDatePickerRange', {
    staticClass: "marg-1-bottom",
    attrs: {
      "dateShortCutsProps": _vm.dateShortCutsSorted,
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "datesChanged": _vm.setDates
    }
  }), _vm._v(" "), _c('SubsUserPanelLessons', {
    attrs: {
      "dates": _vm.absentDates,
      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
      "calendarId": _vm.user.user_calendar_id,
      "subToAdd": _vm.subToAdd
    },
    on: {
      "changed": _vm.updateSelectedEventIds,
      "updatedArr": _vm.updateDbEventsWithSubs
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide-in__sidebar"
  }, [_c('SubsUserPanelSubs', {
    attrs: {
      "selectedEvents": _vm.selectedEvents
    },
    on: {
      "addSub": _vm.addSubToEvents
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeUp"
    }
  }, [(_vm.dbEventsWithSubs.length > 0) ? _c('div', {
    staticClass: "slide-in__footer shadow"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "marg-10-left bttn bttn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + _vm._s(_vm.saveCountSuffix) + "\n          ")])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), (_vm.isClosingWithoutSaving) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_save')) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        _vm.isClosingWithoutSaving = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [_c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-10-right",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.no_close_without_saving')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitution.yes_save_my_changes')))])])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2176c8f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsUserPanel/SubsUserPanel.vue
// module id = 1798
// module chunks = 1